import type { UserType } from '@/store/types/user'
import { Base64 } from '@/lib/utils/shared/base64'
import type { MarketExceptionType } from '@/constants/MarketExceptions/MarketExceptionTypes'

const generateBecomeAffiliateUrl = ({
  user,
  currentCountry,
  marketExceptions,
}: {
  user: UserType
  currentCountry: string
  marketExceptions: MarketExceptionType | null
}) => {
  const encodedToken = Base64.encode(user.token ?? '')
  const isProduction = process.env.NEXT_PUBLIC_APP_ENV === 'production'

  const defaultBecomeAffiliateUrl = isProduction
    ? `https://upgrade.unicity.com/#/login/sl/${encodedToken}`
    : `https://upgrade.unicityqa.com/master/#/login/sl/${encodedToken}`

  if (!currentCountry) {
    return defaultBecomeAffiliateUrl
  }

  if (!marketExceptions) {
    return defaultBecomeAffiliateUrl
  }

  const becomeAffiliateUrl = marketExceptions.quickLinks?.becomeAffiliateUrl

  if (becomeAffiliateUrl && typeof becomeAffiliateUrl === 'string') {
    const enrollerId = user.customer?.enroller?.id?.unicity

    if (enrollerId) {
      return `${becomeAffiliateUrl}${enrollerId}?lang=jp`
    }

    return defaultBecomeAffiliateUrl
  }

  return defaultBecomeAffiliateUrl
}

export default generateBecomeAffiliateUrl
